import { render, staticRenderFns } from "./phoneDownload.vue?vue&type=template&id=5ceed072"
import script from "./phoneDownload.vue?vue&type=script&lang=js"
export * from "./phoneDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports